export default "__VITE_ASSET__CpvkOnHB__"